import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminShared.css";
import { API_BASE_URL } from "../config";

const STATUS_OPTIONS = ["New", "Contacted", "Closed"];

export default function AdminConsultation() {
  const navigate = useNavigate();
  const [consultations, setConsultations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});

  useEffect(() => {
    const adminInfo = localStorage.getItem("adminInfo");
    if (!adminInfo) return navigate("/admin");
    fetchConsultations();
  }, [navigate]);

  const fetchConsultations = async () => {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("adminInfo"))?.token;
      const res = await fetch(`${API_BASE_URL}/api/consultation/admin`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await res.json();
      setConsultations(
        (result.data || []).sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
        ),
      );
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const toggleReadMore = (id) => {
    setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Purge this consultation request?")) return;
    try {
      const token = JSON.parse(localStorage.getItem("adminInfo"))?.token;
      await fetch(`${API_BASE_URL}/api/consultation/admin/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchConsultations();
    } catch (err) {
      console.error(err);
    }
  };

  const handleStatusChange = async (id, status) => {
    try {
      const token = JSON.parse(localStorage.getItem("adminInfo"))?.token;
      await fetch(`${API_BASE_URL}/api/consultation/admin/${id}/status`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status }),
      });
      setConsultations((prev) =>
        prev.map((c) => (c._id === id ? { ...c, status } : c)),
      );
    } catch (err) {
      console.error(err);
    }
  };

  if (loading)
    return (
      <div className="admin-list-container">
        <p style={{ padding: "100px", textAlign: "center" }}>
          ⏳ Aggregating Consultation Nodes...
        </p>
      </div>
    );

  return (
    <div className="admin-list-container">
      <header className="admin-list-header">
        <div className="header-left-group">
          <img src="/logo.png" alt="FlyTutor" className="admin-header-logo" />
          <h1 className="admin-header-title">Advisory Queue</h1>
        </div>
        <button
          className="module-badge"
          style={{ cursor: "pointer", background: "#059669", border: "none" }}
          onClick={fetchConsultations}
        >
          Sync Requests 🔄
        </button>
      </header>

      <div className="admin-list-content">
        <div className="admin-info-bar">
          <div className="admin-user-tag">
            <div className="dot" style={{ background: "#059669" }}></div>
            Status: Consultation Manager Online
          </div>
          <div
            className="admin-status-badge"
            style={{
              background: "#ecfdf5",
              color: "#065f46",
              fontSize: "0.75rem",
              fontWeight: 800,
            }}
          >
            {consultations.length} INCOMING TICKETS
          </div>
        </div>

        <div className="admin-table-wrapper">
          <table className="elite-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Participant</th>
                <th>Inquiry Vector</th>
                <th>Workflow Status</th>
                <th>Temporal Node</th>
                <th>Operations</th>
              </tr>
            </thead>
            <tbody>
              {consultations.length === 0 ? (
                <tr>
                  <td
                    colSpan="6"
                    style={{
                      textAlign: "center",
                      padding: "100px",
                      color: "#94a3b8",
                    }}
                  >
                    <div style={{ fontSize: "2rem", marginBottom: "15px" }}>
                      💬
                    </div>
                    No consultation requests detected in buffer.
                  </td>
                </tr>
              ) : (
                consultations.map((c, i) => (
                  <tr key={c._id}>
                    <td>{i + 1}</td>
                    <td>
                      <div style={{ fontWeight: 700 }}>{c.name}</div>
                      <div style={{ fontSize: "0.8rem", color: "#64748b" }}>
                        {c.email}
                      </div>
                      <div style={{ fontSize: "0.8rem", color: "#64748b" }}>
                        {c.number}
                      </div>
                    </td>
                    <td style={{ maxWidth: "300px" }}>
                      <div
                        style={{
                          fontSize: "0.9rem",
                          color: "#475569",
                          lineHeight: "1.4",
                          display: "-webkit-box",
                          WebkitLineClamp: expandedRows[c._id] ? "unset" : "2",
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {c.message}
                      </div>
                      {c.message?.length > 80 && (
                        <button
                          onClick={() => toggleReadMore(c._id)}
                          style={{
                            background: "none",
                            border: "none",
                            color: "#10b981",
                            fontSize: "0.75rem",
                            fontWeight: 700,
                            cursor: "pointer",
                            padding: "4px 0",
                          }}
                        >
                          {expandedRows[c._id]
                            ? "HIDE CONTENT ↑"
                            : "READ COMPLETELY ↓"}
                        </button>
                      )}
                    </td>
                    <td>
                      <select
                        className={`status-tag status-${c.status?.toLowerCase()}`}
                        value={c.status}
                        onChange={(e) =>
                          handleStatusChange(c._id, e.target.value)
                        }
                        style={{
                          border: "none",
                          cursor: "pointer",
                          outline: "none",
                        }}
                      >
                        {STATUS_OPTIONS.map((s) => (
                          <option key={s} value={s}>
                            {s.toUpperCase()}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td>
                      <div style={{ fontWeight: 600 }}>
                        {new Date(c.createdAt).toLocaleDateString("en-IN")}
                      </div>
                      <div style={{ fontSize: "0.8rem", color: "#94a3b8" }}>
                        {new Date(c.createdAt).toLocaleTimeString("en-IN")}
                      </div>
                    </td>
                    <td>
                      <button
                        className="action-btn-elite btn-delete"
                        onClick={() => handleDelete(c._id)}
                      >
                        <span>🗑️</span> Purge
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
